import styled, { css } from 'styled-components'
import SelectedIconImage from '../../../../../src/assets/icons/tick-selected.svg'
import GalleryIconImage from '../../../../../src/assets/icons/gallery.svg'

type SelectButtonProps = {
    isSelected: boolean
}

export const UnitCardContainer = styled.div<SelectButtonProps>(
    ({ theme, isSelected }) => css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 1rem;
        gap: 1rem;

        ${isSelected &&
        css`
            border: 1.5px solid ${theme.colors.tfwBlack99};
            border-radius: 1rem;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 1px 10px rgba(0, 0, 0, 0.04),
                0px 4px 5px rgba(0, 0, 0, 0.06);
        `}
    `,
)

export const ImageContainer = styled.div`
    position: relative;
    width: calc(30% - 0.5rem);
`

export const Image = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
`

export const GalleryIcon = styled(GalleryIconImage)`
    position: absolute;
    top: 0.375rem;
    right: 0.375rem;
    cursor: pointer;
`

export const UnitDetails = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(70% - 0.5rem);
    gap: 1rem;
`

export const UnitDetailsSubcontainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`

export const UnitDetailsDatacontainer = styled.div`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`

export const Divider = styled.div`
    width: 0.0625rem;
    height: 100%;
    background-image: linear-gradient(to bottom, #d3d3d3 30%, transparent 0%);
    background-size: 0.0625rem 0.094rem;
    background-repeat: repeat-y;
    margin: 0 0.75rem;
`

export const UnitTitle = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

export const Pricetext = styled.div`
    position: relative;
    width: 100%;
    text-align: center;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    /* Create a hidden dummy for centering */
    &::before {
        content: attr(data-text);
        visibility: hidden;
        display: inline-block;
        height: 0;
        overflow: hidden;
        white-space: nowrap;
    }
`

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    min-width: 130px;
    line-height: 24px;
    width: 30%;
`

export const SelectButton = styled.div<SelectButtonProps>(
    ({ theme, isSelected }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        width: 100%;
        margin-top: 0.5rem;
        padding: 0.25rem 0.5rem;
        ${isSelected &&
        css`
            background: ${theme.colors.tfwGrey};
        `}
        border: ${isSelected ? '2px' : '1px'} solid ${theme.colors.tfwBlack99};
        border-radius: 0.5rem;
        cursor: pointer;
    `,
)

export const FreeCancelationText = styled.div(
    ({ theme }) => css`
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${theme.colors.tfwPositiveMedium};
        font-family: ${theme.typography.font.family.lato};
        font-size: 12px;
    `,
)

export const SelectedIcon = styled(SelectedIconImage)`
    width: 0.875rem;
    height: 0.875rem;
`

export const UnitDescription = styled.div``

export const ViewDetailsText = styled.span`
    text-decoration: underline;
    cursor: pointer;
    margin-left: 0.25rem;
    white-space: nowrap;
`
